<template>
  <div class="flex flex-col c-spacing">

    <label
      v-for="option in options" 
      :key="option.value"
      :class="{ 'bg-blue-1000 text-white s-checked bg-blue-flash': isChecked(option.value) }"
      class="rounded-full px-4 py-3 border-2 border-blue-1000 s-hover cursor-pointer"
    >
      <input
        @click="local_navigate(option.value)"
        type="radio" 
        :value="option.value"
      />
      <span class="ml-2 text-xl font-bold">
        {{ option.label }}
      </span>
    </label>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Radios',
  computed: {
    ...mapState([
      'step',
    ]),
    data: {
      get () {
        return this.$store.state.exam_responses?.[this.question.prompt];
      },
      set(response) {
        this.$store.commit('SET_PROMPT_AND_QUESTION', { prompt: this.question.prompt, response });
      }
    },
  },
  props: {
    question: {
      required: true,
      type: Object
    },
    options: {
      required: true,
      type: Array,
    }
  },
  methods: {
    ...mapActions([
      'navigate',
    ]),
    local_navigate(e) {
      // this model replaces v-model so we can effectively navigate on changes, since a watcher was unreliable for some reason
      this.data = e; 
      setTimeout(() => { // waiting 300ms allows the background color change take effect. Mobile safari navigated forwards before changing the bg color of the buttons
        this.navigate(true); // automatically move forwards
      }, 225);
    },  
    isChecked(value) { // radio's data will always be a string, so compare it
      if (this.data && this.data == value) {
        return true;
      } else return false;
    },
  },
}
</script>



<style lang="scss" scoped>

.c-spacing {
  label {
    margin-bottom: 0.65em!important;
    min-width: 18rem;
  }
  input {
    display: none!important;
  }
}

</style>